import React from 'react';
import PropTypes from 'prop-types';
import DrillHeader from './DrillHeader';
import DrillHero from './DrillHero';
import DrillSetUp from './DrillSetUp';
import SelectContentType from '../Content/SelectContentType';
import FadeOut from '../Global/Misc/FadeOut';
import ContentRestrictedMessage from '../Global/Messages/ContentRestrictedMessage';
import SignUpMessage from '../Global/Messages/SignUpMessage';
import ShareDropdown from '../Global/Sharing/ShareDropdown';
import DiagramImage from '../Content/DiagramImage';
import Image from '../Content/Image';
import contentTypeName from '../../utils/contentTypeName';
import staticUrl from "../../utils/staticPath";

const DrillContent = ({ content, commentCount, doIFollow, onFollowClick, access, drillActions, loggedInUser, inSession, organisation }) => {
  let mainContent;

  if (content.type === `pitchdiagram`) {
    const imageObject = { content_id: content.id, src: content.snapshot_url, type: `pitch-diagram-snapshot-image` };
    mainContent = <DiagramImage image={imageObject} loggedInUserId={loggedInUser.id} authorId={content.author.id} />;
  } else {
    mainContent = [];

    // Really hacky and not ideal but needed - because we don't print hero images (because CMS created drills have 'presentational' hero images that aren't needed when printing)
    // and also because it is impossible to correctly float the hero image as it has lots of container <div>s
    // If it is a user created drill that contains a hero image we duplicate the hero image as the first item inside the main content array as users could add diagram images into the hero
    // and therefore want it to be printed. This is hidden in CSS by default, but when printing we show it.
    // Granted, all of this is confusing but until we have a standarised way of printing across both user and CMS created drills it is unavoidable
    if (content.cms_created === false && content.image.data.src) {
      mainContent.push(<div className="user-created-hero-print-fix"><Image image={content.image.data} /></div>);
    }

    const selectContentType = object => (
      mainContent.push(<SelectContentType key={object.id} content={object} loggedInUserId={loggedInUser.id} authorId={content.author.id} inSession />,
    ));

    if (content.main_content) {
      // If the user cannot access then we only render the first 2 objects in main content (and add a blur in CSS)
      if (access.canIAccess === false) {
        content.main_content.slice(0, 2).map(object => (selectContentType(object)));
        mainContent.push(<FadeOut key="fade-out" />);
      } else {
        content.main_content.map(object => (selectContentType(object)));
      }
    }
  }
  const logoAsset = `${staticUrl()}assets/images/svg/logos.svg#tcm`;
  return (
    <article className="content-area">
      <div className="content-header-new">
        <svg className="print-only icon logo fill-dark icon-tcm"><use xlinkHref={logoAsset} /></svg>
        <div className={`content-type content-bar ${content.type}`}>
          <span>{contentTypeName(content.type)}</span>
          <span className="teaser-age-range">{content.tcm_age_range}</span>
        </div>

        {inSession ? (
          <h2 className="content-title big-heading">{content.title}</h2>
        ) : (
          <h1 className="content-title big-heading">{content.title}</h1>
        )}

        <p className="content-summary text-grey h2">{content.summary}</p>
        <DrillHeader content={content} commentCount={commentCount} doIFollow={doIFollow} onFollowClick={onFollowClick} loggedInUser={loggedInUser} />
        {drillActions}
      </div>

      <DrillHero content={content} access={access} loggedInUserId={loggedInUser.id} />
      {content.type === `drill` &&
        <DrillSetUp content={content} />
      }

      <div className="wysiwyg-area">
        {mainContent}
      </div>

      {access.canIAccess === true &&
        <div className="share-after-article">
          <ShareDropdown title={content.title} />
        </div>
      }

      {access.canIAccess === false &&
        <ContentRestrictedMessage access={access} organisation={organisation} border />
      }

      {access.loggedIn === false &&
        <SignUpMessage access={access} author={content.author} />
      }
    </article>
  );
};

DrillContent.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  commentCount: PropTypes.number,
  doIFollow: PropTypes.array,
  onFollowClick: PropTypes.func,
  access: PropTypes.object,
  organisation: PropTypes.object,
  drillActions: PropTypes.object,
  loggedInUser: PropTypes.object,
  inSession: PropTypes.bool,
};

export default DrillContent;



// WEBPACK FOOTER //
// ./library/app/components/Drill/DrillContent.js